export const I18N_NAVBAR_MENU = (t, language) => {
  return [
    { name: "home", path: `/${language}` },
    {
      name: "aboutUs",
      path: `/${language}/${t("aboutUs")}`,
      children: [
        { name: "aboutUs", path: `/${language}/${t("aboutUs")}` },
        { name: "leadership", path: `/${language}/${t("leadership")}` },
      ],
    },
    { name: "shopeepay", path: `/${language}/${t("shopeepay")}` },
    { name: "moneyPlus", path: `/${language}/${t("moneyPlus")}` },
    { name: "spaylater", path: `/${language}/${t("spaylater")}` },
    { name: "sloan", path: `/${language}/${t("sloan")}` },
    {
      name: "insurance",
      path: `/${language}/${t("insurance")}`,
      children: [
        { name: "insurance", path: `/${language}/${t("insurance")}` },
        {
          name: "carInsurance",
          path: `/${language}/${t("insurance")}/${t("car")}`,
        },
        {
          name: "motorcycleInsurance",
          path: `/${language}/${t("insurance")}/${t("motorcycle")}`,
        },
        {
          name: "travelInsurance",
          path: `/${language}/${t("insurance")}/${t("travel")}`,
        },
        {
          name: "personalAccidentInsurance",
          path: `/${language}/${t("insurance")}/${t("personalAccident")}`,
        },
      ],
    },
    {
      name: "merchant",
      path: `/${language}/${t("merchant")}`,
      children: [
        {
          name: "beAPartner",
          path: `/${language}/${t("merchant")}/${t("beAPartner")}`,
        },
        {
          name: "sloanForSellers",
          path: `/${language}/${t("merchant")}/${t("sloanForSellers")}`,
        },
        {
          name: "quickfunds",
          path: `/${language}/${t("merchant")}/${t("quickFunds")}`,
        },
      ],
    },
    {
      name: "customerService",
      path: `/${language}/${t("customerService")}`,
    },
  ];
};
